module.exports = require("tty");